// @flow

/**
 * Initialise Google Analytics.
 *
 * You will also need to configure Google Analytics by calling configureGoogleAnalytics()
 */

import history                      from '../../router/history';
import configureGoogleAnalytics     from './configureGoogleAnalytics';
import getGoogleAnalyticsTrackingId from './getGoogleAnalyticsTrackingId';


const initGoogleAnalytics = () => {

  const gaTrackingId = getGoogleAnalyticsTrackingId();

  if (!gaTrackingId) {
    return;
  }

  window.dataLayer = window.dataLayer || [];

  configureGoogleAnalytics();

  // Inject the GTag JavaScript file
  const gaScript = document.createElement('script');
  gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${gaTrackingId}`);
  gaScript.setAttribute('async', 'async');
  document.head && document.head.appendChild(gaScript);

  function logPageView(page_path) {
    // $FlowFixMe
    require('./gtag').default('config', gaTrackingId, {page_path});
  }

  history.listen((location) => {
    logPageView(location.pathname);
  });
};

export default initGoogleAnalytics;



// WEBPACK FOOTER //
// ./src/analytics/google-analytics/initGoogleAnalytics.js